import React from "react";
import Material from "./MaterialComponent";
import { stainless, exotics, aluminumAlloys, steel } from "./materialslist";
import stainlessBackground from "images/background-stainless.jpg";
import exoticMetalsBackground from "images/background-exotic-metals.jpg";
import aluminumBackground from "images/background-aluminum.jpg";
import steelBackground from "images/background-steel.jpg";

const MaterialContainer = () => (
  <div>
    <Material data={stainless} background={stainlessBackground} />
    <Material data={exotics} background={exoticMetalsBackground} />
    <Material data={aluminumAlloys} background={aluminumBackground} />
    <Material data={steel} background={steelBackground} />
  </div>
);

export default MaterialContainer;



// WEBPACK FOOTER //
// ./src/pages/Materials/MaterialComponent/MaterialContainer.js